import { Currencies } from './types';

export const SWAP_TOKEN_URL_PATH = 'accounts/swapToken';
export const AUTH401_ACTION_TYPE = 'auth/401';
export const DATE_FORMAT = 'MMMM D, HH:mm';
export const CURRENCY = Currencies.EUR;
export const TAX_RATE = 0.2;

// App version - this should be updated during build process
export const APP_VERSION = process.env.REACT_APP_VERSION || '0.0.0';
